module.exports = __webpack_public_path__ + "img/upload-static-icon.a4588c0f.svg";